const convertToHoursAndMinutes = (timeInMilliseconds) => {
  if (timeInMilliseconds) {
    // Convert milliseconds to minutes
    const timeInMinutes = Math.floor(timeInMilliseconds / 60000);

    // Calculate hours and minutes
    const hours = Math.floor(timeInMinutes / 60);
    const minutes = timeInMinutes % 60;

    let period = 'AM';
    let formattedHours = hours;

    // Convert hours to 12-hour format and determine AM or PM
    if (hours >= 12) {
      period = 'PM';
      formattedHours = hours === 12 ? 12 : hours - 12;
    } else if (hours === 0) {
      formattedHours = 12; // 12 AM
    }

    // Ensure minutes are formatted with leading zero if needed
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    // Combine hours, minutes, and period into a string
    return `${formattedHours}:${formattedMinutes} ${period}`;
  }
};
export { convertToHoursAndMinutes }




